/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bowling_medium'
export default icon
